export default "__VITE_ASSET__61509ad3__"